import { SRMembersListFilters } from '../../../styledComponents/ProductMembersList/SRMembersList/SRMembersFilters/srMembersFilters.models';

export const srPageFilters = [
  SRMembersListFilters.Search,
  SRMembersListFilters.Plan,
  SRMembersListFilters.MemberType,
  SRMembersListFilters.RenewStatus,
];
